import { render, staticRenderFns } from "./AddClaimAgency.vue?vue&type=template&id=99a452c2&"
import script from "./AddClaimAgency.vue?vue&type=script&lang=js&"
export * from "./AddClaimAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports